/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PersonNameDTO
 */
export interface PersonNameDTO  {
    /**
     * 
     * @type {number}
     * @memberof PersonNameDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonNameDTO
     */
    surname?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonNameDTO
     */
    givenname?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonNameDTO
     */
    salutation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersonNameDTO
     */
    isMain?: boolean;
}

/**
 * Check if a given object implements the PersonNameDTO interface.
 */
export function instanceOfPersonNameDTO(value: object): value is PersonNameDTO {
    return true;
}

export function PersonNameDTOFromJSON(json: any): PersonNameDTO {
    return PersonNameDTOFromJSONTyped(json, false);
}

export function PersonNameDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonNameDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'surname': json['surname'] == null ? undefined : json['surname'],
                  'givenname': json['givenname'] == null ? undefined : json['givenname'],
                  'salutation': json['salutation'] == null ? undefined : json['salutation'],
                  'isMain': json['isMain'] == null ? undefined : json['isMain'],
    };
}

export function PersonNameDTOToJSON(json: any): PersonNameDTO {
    return PersonNameDTOToJSONTyped(json, false);
}

export function PersonNameDTOToJSONTyped(value?: PersonNameDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'surname': value['surname'],
        'givenname': value['givenname'],
        'salutation': value['salutation'],
        'isMain': value['isMain'],
    };
}


